'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../../../../util');

var _util2 = _interopRequireDefault(_util);

var _input = require('../../../../input');

var _input2 = _interopRequireDefault(_input);

var _checkbox = require('../../../../checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _button = require('../../../../button');

var _button2 = _interopRequireDefault(_button);

var _icon = require('../../../../icon');

var _icon2 = _interopRequireDefault(_icon);

var _draggable = require('../../../../draggable');

var _draggable2 = _interopRequireDefault(_draggable);

require('./index.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var CustomFilter = function (_M$BaseComponent) {
  _inherits(CustomFilter, _M$BaseComponent);

  function CustomFilter(props) {
    _classCallCheck(this, CustomFilter);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CustomFilter).call(this, props));

    var data = (props.data || []).map(function (item) {
      return _extends({}, item);
    });
    Object.assign(_this.state, {
      keyword: '',
      data: data,
      showData: data.slice()
    });
    return _this;
  }

  _createClass(CustomFilter, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data) {
        var data = (nextProps.data || []).map(function (item) {
          return _extends({}, item);
        });
        this.setState({
          data: data,
          showData: data.slice()
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var baseCls = 'custom-filter';
      var custom = this.props.custom;
      var _state = this.state;
      var keyword = _state.keyword;
      var showData = _state.showData;


      var draggableProps = {
        className: baseCls + '__list',
        data: showData,
        idField: 'code',
        itemClass: baseCls + '__list-item',
        options: {
          sort: true,
          onUpdate: function onUpdate(dragInfo) {
            var d = dragInfo.data;
            var oldIndex = dragInfo.oldIndex;
            var newIndex = dragInfo.newIndex;
            var data = _this2.state.data;

            data.splice(oldIndex, 1);
            data.splice(newIndex, 0, d);
            _this2.setState({ data: data, showData: data.slice() });
          }
        },
        format: function format(item, key, index, array) {
          var label = item.label;
          var code = item.code;
          var show = item.show;

          return _react2.default.createElement(
            'div',
            { key: code },
            _react2.default.createElement(
              _checkbox2.default,
              { className: baseCls + '__item-checkbox',
                checked: show,
                onChange: _this2._toggleSelected.bind(_this2, index) },
              label
            ),
            !keyword && _react2.default.createElement(_icon2.default, { className: baseCls + '__item-drag-icon', type: 'round-bars' })
          );
        }
      };

      return _react2.default.createElement(
        'div',
        { className: baseCls },
        _react2.default.createElement(
          'div',
          { className: baseCls + '__search' },
          _react2.default.createElement(_input2.default, { value: keyword,
            size: 'small',
            trigger: 'onChange',
            placeholder: '搜索列表选项',
            onChange: this._onKeywordChange })
        ),
        _react2.default.createElement(_draggable2.default, draggableProps),
        _react2.default.createElement(
          'div',
          { className: baseCls + '__operation' },
          _react2.default.createElement(
            'div',
            { className: baseCls + '__operation__custom' },
            custom
          ),
          _react2.default.createElement(
            'div',
            { className: baseCls + '__operation__base' },
            _react2.default.createElement(_button2.default, { className: baseCls + '__operation__base-btn',
              size: 'small', label: '取消', onClick: this._cancel }),
            _react2.default.createElement(_button2.default, { className: baseCls + '__operation__base-btn',
              size: 'small', type: 'primary', label: '确定', onClick: this._confirm })
          )
        )
      );
    }
  }, {
    key: '_onKeywordChange',
    value: function _onKeywordChange(keyword) {
      var data = this.state.data;

      var showData = this._filterData(data, keyword);
      //根据keyword过滤展示的数据
      this.setState({ keyword: keyword, showData: showData });
    }
  }, {
    key: '_filterData',
    value: function _filterData(data, keyword) {
      return data.filter(function (item) {
        return item.label.indexOf(keyword) != -1;
      });
    }
  }, {
    key: '_cancel',
    value: function _cancel() {
      var onCancel = this.props.onCancel;

      onCancel && onCancel();
    }
  }, {
    key: '_confirm',
    value: function _confirm() {
      var data = this.state.data;
      var onConfirm = this.props.onConfirm;

      onConfirm && onConfirm(data);
    }
  }, {
    key: '_toggleSelected',
    value: function _toggleSelected(index, e) {
      var checked = e.target.checked;
      var _state2 = this.state;
      var data = _state2.data;
      var showData = _state2.showData;
      var keyword = _state2.keyword;

      data.find(function (item) {
        return item.code == showData[index].code;
      }).show = checked;
      showData = this._filterData(data, keyword);
      this.setState({ data: data, showData: showData });
    }
  }]);

  return CustomFilter;
}(_util2.default.BaseComponent);

exports.default = CustomFilter;